import { IndividualAnalysis } from '../hooks/types';

/**
 * Builds a synthesis prompt from individual demo analyses.
 * This prompt is sent to the AI to create a comprehensive summary
 * across all analyzed demos.
 */
export const buildSynthesisPrompt = (analyses: IndividualAnalysis[]): string => {
	const completedAnalyses = analyses.filter(a => a.status === 'complete');
	const count = completedAnalyses.length;

	if (count === 0) {
		return 'No completed analyses available for synthesis.';
	}

	const formattedAnalyses = completedAnalyses
		.map((a, i) => {
			const header = a.demoName
				? `--- Demo ${i + 1}: ${a.demoName} (${a.demoDate || 'Unknown date'}) ---`
				: `--- Demo ${i + 1} ---`;
			return `${header}\n${a.analysis}`;
		})
		.join('\n\n');

	return `You have analyzed ${count} individual sales demo calls. Below are the individual analyses:

${formattedAnalyses}

--- End of Individual Analyses ---

Please synthesize these ${count} analyses into a comprehensive report:

1. **Overall Performance Summary**: High-level assessment across all demos.

2. **Common Strengths**: Patterns of what the SDR consistently does well (cite specific demos).

3. **Recurring Areas for Improvement**: Issues appearing across multiple demos (cite specific demos).

4. **Trend Analysis**: Any progression or regression in performance across the time period.

5. **Priority Recommendations**: Top 3 actionable improvements with highest impact.

Focus on patterns and trends rather than repeating individual feedback. Be specific and actionable.`;
};
